// src/components/Chatbot.js

import React, { useEffect } from "react";

/** Apply brand color to Proto launcher text/icons (replaces default black). Walks light DOM + shadow roots. */
function recolorProtoChatChrome() {
  const base =
    getComputedStyle(document.documentElement).getPropertyValue("--thm-base").trim() || "#753918";

  function paintElement(el) {
    if (!el || el.nodeType !== Node.ELEMENT_NODE) return;
    el.style.setProperty("color", base, "important");
    el.querySelectorAll?.("svg").forEach((svg) => {
      svg.style.setProperty("fill", base, "important");
      svg.style.setProperty("color", base, "important");
    });
  }

  function visit(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const t = node.textContent || "";
      if (/chat\s+with\s+me/i.test(t) || /^chat\s+with/i.test(t.trim())) {
        paintElement(node.parentElement);
      }
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    const el = node;
    if (el.tagName === "IFRAME" || el.tagName === "SCRIPT" || el.tagName === "STYLE") return;

    if (el.shadowRoot) {
      visit(el.shadowRoot);
    }
    for (const c of el.childNodes) {
      visit(c);
    }
  }

  visit(document.body);

  /* Launcher often uses black text in a fixed bottom-right chip — recolor if it still matches */
  document.querySelectorAll("body *").forEach((el) => {
    if (!el || el.nodeType !== Node.ELEMENT_NODE) return;
    if (el.closest("iframe")) return;
    const txt = (el.textContent || "").trim();
    if (!/chat/i.test(txt) || txt.length > 120) return;
    const cs = getComputedStyle(el);
    if (cs.position !== "fixed") return;
    const rect = el.getBoundingClientRect();
    if (rect.bottom < window.innerHeight - 80) return;
    if (rect.left < window.innerWidth - 360) return;
    const col = cs.color;
    if (col === "rgb(0, 0, 0)" || col === "rgba(0, 0, 0, 1)") {
      paintElement(el);
    }
  });
}

const Chatbot = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://embed.proto.cx/index.umd.js";
    script.type = "text/javascript";
    script.async = true;

    script.onload = () => {
      if (window.proto) {
        window.proto.init({
          id: "01J41W3DJS1Q07YW4YHRCX78A7",
        });
      }
      recolorProtoChatChrome();
    };

    document.head.appendChild(script);

    let raf = 0;
    const schedule = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(recolorProtoChatChrome);
    };

    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });

    const interval = window.setInterval(recolorProtoChatChrome, 1500);

    return () => {
      cancelAnimationFrame(raf);
      observer.disconnect();
      window.clearInterval(interval);
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return null;
};

export default Chatbot;
